module.exports = __webpack_public_path__ + "footer-twitter-extra-small.3zx3_Wxc.svg";